var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.745 9.603c-.53.53-1.39.53-1.92 0l-4.468-4.47v13.01a1.358 1.358 0 0 1-2.714 0V5.133l-4.469 4.47a1.358 1.358 0 0 1-1.92-1.92L9.04.897l.097-.086.005-.005-.102.091c.052-.052.108-.097.165-.14.014-.012.03-.021.046-.031a.596.596 0 0 1 .062-.04L9.37.655 9.442.62 9.488.6 9.57.57l.046-.015.081-.021.057-.011A.583.583 0 0 1 9.83.51a.497.497 0 0 1 .06-.007L9.976.5h.046c.029 0 .058.002.087.004L10 .5c.057 0 .115.003.17.01l.074.012.059.012.08.021a.482.482 0 0 1 .046.014l.083.03.046.02c.024.011.048.022.072.035l.058.033a.633.633 0 0 1 .061.039l.046.031.064.05c.034.027.068.058.1.09l6.787 6.786c.53.53.53 1.39 0 1.92Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.2afcd88bfe179f6d809dbc474cb8743d.svg";